import { render, staticRenderFns } from "./FinancialRemarkDialog.vue?vue&type=template&id=2cc1c090"
import script from "./FinancialRemarkDialog.vue?vue&type=script&lang=js"
export * from "./FinancialRemarkDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/test-crmeb-admin-front-service/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2cc1c090')) {
      api.createRecord('2cc1c090', component.options)
    } else {
      api.reload('2cc1c090', component.options)
    }
    module.hot.accept("./FinancialRemarkDialog.vue?vue&type=template&id=2cc1c090", function () {
      api.rerender('2cc1c090', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/financial/statement/components/FinancialRemarkDialog.vue"
export default component.exports